import React from "react"
import { Container, Image, Name, InMovieName, ThumbSkeleton } from "./styles/actor"

export default function Actor({ children, to, ...rest }) {
  return (
    <Container to={to} {...rest}>
      {children}
    </Container>
  )
}

Actor.Thumbnail = function ActorThumbnail({ src, ...rest }) {
  return <Image src={src} />
}
Actor.ThumbSkeleton = function ActorThumbSkeleton({ children, ...rest }) {
  return <ThumbSkeleton {...rest}>{children}</ThumbSkeleton>
}

Actor.Name = function ActorName({ children, ...rest }) {
  return <Name {...rest}>{children}</Name>
}

Actor.InMovieName = function ActorInMovieName({ children, ...rest }) {
  return <InMovieName {...rest}>{children}</InMovieName>
}
